import * as React from "react";
import { EventCardSectionItem } from "../../EventCardSectionItem";

export const renderStartsIn = (startsIn: string, kickOffTime: string) =>
    <>
        <EventCardSectionItem content={startsIn} className="rj-ev-list__ev-card__start rj-ev-list__ev-card__start-in" data-uat="div-ev-list-ev-card-start-in" />
        <EventCardSectionItem content={kickOffTime} className="rj-ev-list__ev-card__start rj-ev-list__ev-card__start-time" data-uat="div-ev-list-ev-card-start-time" />
    </>